export const translation = {
  // Navigation
  nav: {
    home: 'Início',
    categories: 'Categorias',
    guides: 'Guias',
    shoppingGuide: 'Guia de Compras',
    about: 'Sobre',
    contact: 'Contato',
    searchPlaceholder: 'Pesquise produtos, categorias, guias...',
  },

  // Language selector
  lang: {
    en: 'English',
    pt: 'Português',
    de: 'Deutsch',
    current: 'Português',
  },

  // Hero Section
  hero: {
    eyebrow: 'CSSBuy Spreadsheet • Guia Independente • Atualizado',
    h1: 'CSSBuy Spreadsheet: encontre, compare e pesquise produtos com mais confiança',
    subtitle: 'Explore uma central independente de CSSBuy Spreadsheet com listas organizadas, categorias, guias de compra, informações de QC, armazenamento e envio — tudo em um só lugar.',
    ctaPrimary: 'Explorar CSSBuy Spreadsheet',
    ctaSecondary: 'Visitar o Site Principal',
  },

  // Categories Section
  categories: {
    h2: 'Explore o CSSBuy Spreadsheet por categoria',
    subtitle: 'Navegue por nossas categorias de produtos organizadas e encontre os recursos que precisa para sua próxima compra.',
    viewAll: 'Ver todas as categorias',
    items: {
      shoes: 'Tênis',
      hoodies: 'Moletom/Suéter',
      tshirts: 'Camisetas',
      jackets: 'Jaquetas',
      pants: 'Calças/Shorts',
      headwear: 'Bonés e Gorros',
      sets: 'Conjuntos',
      underwear: 'Roupas Íntimas',
      jersey: 'Camisa de Time',
      accessories: 'Acessórios',
      bags: 'Bolsas e Mochilas',
      belts: 'Cintos',
      perfumes: 'Perfumes',
      other: 'Outros Itens',
    },
  },

  // Products Section
  products: {
    title: 'Produtos em Destaque do Kakobuy Spreadsheet',
    subtitle: 'Navegue por nossa coleção selecionada de produtos verificados. Clique em qualquer item para ver detalhes e comprar no site principal.',
    viewAll: 'Ver todos em {{category}}',
    buyNow: 'Comprar Agora',
  },

  // Dropdown
  dropdown: {
    label: 'Selecionar Categoria',
    placeholder: 'Escolha uma categoria de produto...',
  },

  // Main CTA Buttons
  cta: {
    cssbuySpreadsheet: 'CSSBuy Spreadsheet',
    buyItNow: 'Comprar Agora',
  },

  // Guide Section
  guide: {
    h2: 'Comece pelo nosso guia CSSBuy Spreadsheet',
    text: 'Aprenda como pesquisar produtos, comparar opções e entender informações de QC, armazenamento e envio de forma mais organizada.',
    cta: 'Ler o Guia Completo',
  },

  // Review Section
  review: {
    h2: 'CSSBuy Review: o que você deve saber',
    text: 'Consulte nosso review independente sobre processo de compra, QC, armazenamento, envio, custos e pontos importantes para novos usuários.',
    cta: 'Ler CSSBuy Review',
  },

  // Shipping Section
  shipping: {
    h2: 'CSSBuy Shipping Cost: entenda o que influencia o preço',
    text: 'O custo internacional pode variar conforme destino, peso, volume, método de envio, embalagem e outras condições. Aprenda como pesquisar os custos antes de enviar seu pacote.',
    cta: 'Ver Guia de Shipping Cost',
  },

  // Trust section
  trust: {
    tag1: 'Recurso Independente',
    tag2: 'Guias Multilíngues',
    tag3: 'Pesquisa Organizada',
    tag4: 'Conteúdo Atualizado',
  },

  // FAQ
  faq: {
    h2: 'Perguntas Frequentes',
    q1: 'O que é CSSBuy Spreadsheet?',
    a1: 'Um recurso organizado para pesquisar e comparar produtos, categorias e informações relacionadas ao processo de compra.',
    q2: 'CSSBuy Spreadsheet é oficial?',
    a2: 'Não. Este site é um recurso independente e não é operado, patrocinado ou endossado pelo CSSBuy.',
    q3: 'CSSBuy é legítimo?',
    a3: 'Consulte nosso guia independente sobre legitimidade, segurança, pagamentos, QC e envio.',
    q4: 'Quanto custa o envio CSSBuy?',
    a4: 'O custo depende de destino, peso, volume, rota e características do pacote.',
    q5: 'Onde encontro CSSBuy Spreadsheet?',
    a5: 'Use nosso diretório organizado por categorias e guias.',
  },

  // Final CTA
  finalCta: {
    h2: 'Pronto para pesquisar de forma mais inteligente?',
    text: 'Explore o CSSBuy Spreadsheet, compare informações e encontre os guias certos para sua próxima pesquisa.',
    ctaPrimary: 'Explorar CSSBuy Spreadsheet',
    ctaSecondary: 'Visitar o Site Principal',
  },

  // Footer
  footer: {
    disclaimer: 'CSSBuy Spreadsheet é um recurso de informação independente e não é afiliado, endossado ou operado pelo CSSBuy.',
    nav: {
      spreadsheet: 'CSSBuy Spreadsheet',
      guide: 'Guia Spreadsheet',
      list: 'Lista Spreadsheet',
      finds: 'Achados Spreadsheet',
      review: 'Review',
      shipping: 'Envio',
      qc: 'QC',
      warehouse: 'Armazém',
      safety: 'Segurança',
      faq: 'FAQ',
      blog: 'Blog',
      editorial: 'Política Editorial',
      about: 'Sobre',
      contact: 'Contato',
      privacy: 'Privacidade',
      terms: 'Termos',
      disclaimer: 'Aviso Legal',
    },
  },

  // SEO / Page titles
  seo: {
    homeTitle: 'CSSBuy Spreadsheet | Hub de Recursos Independente e Guia de Pesquisa',
    homeDesc: 'Recurso independente de CSSBuy Spreadsheet com categorias de produtos organizadas, guias de compra, reviews, custos de envio, informações de QC e dicas de segurança.',
  },

  // Blog / Articles
  blog: {
    h2: 'Últimos Guias CSSBuy Spreadsheet',
    subtitle: 'Explore nossos guias principais cobrindo pesquisa de produtos, reviews, envio, QC, armazém, segurança e mais.',
    readMore: 'Ler Artigo',
    updatedLabel: 'Última atualização',
    backHome: 'Voltar ao Início',
    relatedTitle: 'Guias Relacionados',
    article1: {
      title: 'CSSBuy Spreadsheet 2026: Guia Completo para Pesquisa de Produtos',
      excerpt: 'Aprenda a usar CSSBuy Spreadsheet para pesquisa de produtos organizada, comparação de categorias e decisões de compra informadas.',
      date: 'Agosto 2026',
    },
  },

  // General
  general: {
    independentNotice: 'Recurso Independente — Não afiliado ao CSSBuy.',
  },
};

export default translation;